module.exports = __webpack_public_path__ + "static/media/sun.cb34df2c.png";